import "./App.css";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import Home from "./Pages/Home";
import Events from "./Pages/Events";
import Projects from "./Pages/About";
import Membership from "./Pages/Membership";
import JoinUs from "./Pages/JoinUs";
import Contact from "./Pages/Contact";
// import Finance from "./Finance/Finance";
import Finance from "./Finance/Finance";
import LoginPage from "./Financev2/login";
import Dashboard from "./Financev2/dashboard/dashboard";

const Redirect = () => {
  window.location.href = "https://nuseds.notion.site/";
  return null;
};

const RedirectDonation = () => {
  // Pack Gives Back Fall 2025
  // window.location.href = "https://packgivesback.northeastern.edu/campaigns/club-students-for-the-exploration-and-development-of-space-seds-3?referral_id=68effec3341dcec97c372b04";
  // Standard Location for rest of year
  window.location.href =
    "https://give.northeastern.edu/student-opportunities/DN5059-83.html";
  // Giving Day Spring 2026
  // window.location.href =
  //   "https://givingday.northeastern.edu/s/fund-details?dc=DN5059-83&referralid=WB26GYBY";
  return null;
};

const RedirectDrive = () => {
  window.location.href =
    "https://drive.google.com/drive/folders/17FFbHkSGsigQTAjztW2Y77e1MANzYh9H";
  return null;
};

const RedirectSlack = () => {
  window.location.href =
    "https://join.slack.com/t/sedsnortheastern/shared_invite/zt-3m9daw0dz-EPDi~l_mjFZonsJBuyphiw";
  return null;
};

const RedirectPurchase = () => {
  window.location.href =
    "https://docs.google.com/forms/d/e/1FAIpQLSeTXlNfQZ1Y_lc60mt2Up5bQvg2fHc3jgv0zm2PZQAgM91JDA/viewform?usp=dialog";
  return null;
};

function App() {
  return (
    <MantineProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Redirect />} />
          <Route path="/donate" element={<RedirectDonation />} />
          <Route path="/drive" element={<RedirectDrive />} />
          <Route path="/slack" element={<RedirectSlack />} />
          <Route path="/home" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<Projects />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/joinus" element={<JoinUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/purchase" element={<RedirectPurchase />} />
          {/* <Route index element={<LoginPage />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="/purchase" element={<Finance />}>
            */}
        </Routes>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
